/* Display-only currency converter. Checkout stays in the store currency. */
(function(){
  var C=window.TL_CUR; if(!C) return;
  var FLAGS={AED:'ae',USD:'us',EUR:'eu',GBP:'gb',SAR:'sa',QAR:'qa',KWD:'kw',BHD:'bh',OMR:'om',PHP:'ph',INR:'in',PKR:'pk',EGP:'eg',CAD:'ca',AUD:'au',CNY:'cn',JPY:'jp',TRY:'tr',RUB:'ru',CHF:'ch',BDT:'bd',LKR:'lk',NPR:'np',JOD:'jo',ZAR:'za',SGD:'sg',MYR:'my',THB:'th',KRW:'kr',IDR:'id',NZD:'nz',SEK:'se',NOK:'no',DKK:'dk'};
  var base=C.base, rates={}, order=[base]; rates[base]=1;
  String(C.rates||'').split(',').forEach(function(p){
    var kv=p.split('='); if(kv.length<2) return;
    var code=kv[0].trim().toUpperCase(), r=parseFloat(kv[1]);
    if(code && r>0 && code!==base){ rates[code]=r; order.push(code); }
  });
  var KEY='tl_cur', cur=base;
  try{ var saved=localStorage.getItem(KEY); if(saved && rates[saved]) cur=saved; }catch(e){}
  var lang=document.documentElement.lang||undefined, names=null;
  try{ names=new Intl.DisplayNames([lang||'en'],{type:'currency'}); }catch(e){}

  function fmt(cents,code){
    var v=cents/100*rates[code];
    try{
      return new Intl.NumberFormat(lang,{style:'currency',currency:code,
        minimumFractionDigits:code===base?2:0,maximumFractionDigits:code===base?2:0}).format(v);
    }catch(e){ return code+' '+v.toFixed(0); }
  }
  function symbol(code){
    try{ var parts=new Intl.NumberFormat(lang,{style:'currency',currency:code}).formatToParts(1);
      for(var i=0;i<parts.length;i++) if(parts[i].type==='currency') return parts[i].value; }catch(e){}
    return '';
  }
  function apply(){
    var i,els=document.querySelectorAll('.tl-money[data-cents]');
    if(!els.length&&!document.querySelectorAll('option[data-cents]').length){/* nothing to convert */}
    for(i=0;i<els.length;i++){
      var e=els[i]; if(!e.getAttribute('data-orig')) e.setAttribute('data-orig',e.textContent);
      e.textContent = cur===base ? e.getAttribute('data-orig') : fmt(parseFloat(e.getAttribute('data-cents')),cur);
    }
    var ops=document.querySelectorAll('option[data-cents]');
    for(i=0;i<ops.length;i++){
      var o=ops[i]; if(!o.getAttribute('data-orig')) o.setAttribute('data-orig',o.textContent);
      o.textContent = cur===base ? o.getAttribute('data-orig') : o.getAttribute('data-label')+' \u2013 '+fmt(parseFloat(o.getAttribute('data-cents')),cur);
    }
    var notes=document.querySelectorAll('.cur-note');
    for(i=0;i<notes.length;i++){
      notes[i].hidden = cur===base;
      notes[i].textContent = 'Prices in '+cur+' are estimates. You will be charged in '+base+' at checkout.';
    }
    var f=document.getElementById('tl-cur-flag'), l=document.getElementById('tl-cur-label');
    if(f) f.src='https://flagcdn.com/w40/'+(FLAGS[cur]||'un')+'.png';
    if(l) l.textContent=cur+' '+symbol(cur);
    var items=document.querySelectorAll('#tl-cur-list button');
    for(i=0;i<items.length;i++){ var on=items[i].getAttribute('data-cur')===cur; items[i].className=on?'on':''; }
  }
  function build(){
    var ul=document.getElementById('tl-cur-list'); if(!ul) return;
    ul.innerHTML='';
    order.forEach(function(code){
      var li=document.createElement('li'), b=document.createElement('button'), img=document.createElement('img'), sp=document.createElement('span'), em=document.createElement('em');
      b.type='button'; b.setAttribute('data-cur',code);
      img.className='fl'; img.width=20; img.height=15; img.alt=''; img.loading='lazy'; img.src='https://flagcdn.com/w40/'+(FLAGS[code]||'un')+'.png';
      sp.textContent=code+' '+symbol(code); em.textContent=names?(names.of(code)||''):'';
      sp.appendChild(document.createTextNode(' ')); sp.appendChild(em);
      b.appendChild(img); b.appendChild(sp); li.appendChild(b); ul.appendChild(li);
      b.addEventListener('click',function(){
        cur=code; try{localStorage.setItem(KEY,code);}catch(e){}
        apply(); var d=document.getElementById('tl-cur'); if(d) d.removeAttribute('open');
      });
    });
  }
  function init(){ build(); apply(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
